import Axios from 'axios'
import Qs from 'qs'
let axios_form = Axios.create({
  transformRequest: [function (data) {
    data = Qs.stringify(data)
    return data
  }],
  headers: {'Content-Type': 'application/x-www-form-urlencoded'}
})

export { axios_form, Axios}



// WEBPACK FOOTER //
// ./src/api/resource.js